module.exports = __webpack_public_path__ + "img/logo1.80367d53.png";